import { motion } from "framer-motion";

type Props = {
  title: string;
  hint?: string;
  onStart: () => void;
};

/** 儀式系ページの「TAP TO BEGIN」オーバーレイ。AudioContext / Sensor permission unlock 用 */
export function StartOverlay({ title, hint = "TAP TO BEGIN", onStart }: Props) {
  return (
    <motion.button
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      onClick={onStart}
      className="absolute inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-[var(--color-night-deep)]"
    >
      <motion.div
        animate={{ scale: [1, 1.1, 1], opacity: [0.6, 1, 0.6] }}
        transition={{ duration: 2.4, repeat: Infinity }}
        className="text-7xl text-[var(--color-gold)]"
        style={{ textShadow: "0 0 32px rgba(201,169,97,0.7)" }}
      >
        ⛩
      </motion.div>
      <p
        className="text-lg tracking-[0.3em] text-[var(--color-washi-warm)]"
        style={{ fontFamily: "var(--font-fude)" }}
      >
        {title}
      </p>
      <p className="text-[10px] text-[var(--color-gold-light)] opacity-70 tracking-widest">
        {hint}
      </p>
    </motion.button>
  );
}
